import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, UtilsModule, TranslateModule, RouterLink],
  declarations: [],
  exports: [],
  providers: [ScrollDispatcher, DecimalPipe],
})
export class RightAreaModule {}
